export default __webpack_public_path__ + "static/media/480_store01-en-mobile.9c43b911.png";